(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Arrow", [], factory);
	else if(typeof exports === 'object')
		exports["Arrow"] = factory();
	else
		root["Arrow"] = factory();
})(window, function() {
return 